import { GetServerSidePropsContext } from 'next';
import { apiCall } from '@/utils/api';
import { UserOrgRole } from '@/types/organization';

export const createUserOrganization = async (organizationName: string) => {
  const ROUTE = '/organization/create';

  try {
    const response = await apiCall(
      `${process.env.NEXT_PUBLIC_API}${ROUTE}`,
      {
        method: 'POST',
      },
      { name: organizationName },
    );

    return response;
  } catch (error: any) {
    return { error };
  }
};

export const editUserOrganization = async (
  name: string,
  organizationId: string,
) => {
  const ROUTE = '/organization/edit';

  try {
    const response = await apiCall(
      `${process.env.NEXT_PUBLIC_API}${ROUTE}`,
      {
        method: 'PUT',
      },
      { name, organizationId },
    );

    return response;
  } catch (error: any) {
    return { error };
  }
};

export const addUserToOrganization = async (
  currentOrganization: string,
  email: string,
  role: UserOrgRole,
  nickname?: string,
) => {
  const ROUTE = '/organization/add';

  try {
    const response = await apiCall(
      `${process.env.NEXT_PUBLIC_API}${ROUTE}`,
      {
        method: 'POST',
      },
      { nickname, email, role, organizationId: currentOrganization },
    );

    return response;
  } catch (error: any) {
    return { error };
  }
};

export const removeUserFromOrganization = async (
  email: string,
  currentOrganization: string,
) => {
  const ROUTE = '/organization/revoke';

  try {
    const response = await apiCall(
      `${process.env.NEXT_PUBLIC_API}${ROUTE}`,
      {
        method: 'POST',
      },
      { email, organizationId: currentOrganization },
    );

    return response;
  } catch (error: any) {
    return { error };
  }
};

export const cancelInvitation = async (
  email: string,
  currentOrganization: string,
) => {
  const ROUTE = '/organization/cancel';

  try {
    const response = await apiCall(
      `${process.env.NEXT_PUBLIC_API}${ROUTE}`,
      {
        method: 'POST',
      },
      { email, organizationId: currentOrganization },
    );

    return response;
  } catch (error: any) {
    return { error };
  }
};

export const getUserOrganization = async (
  context: GetServerSidePropsContext,
  currentOrganization?: string | null,
) => {
  const ROUTE = '/organization/info';
  const organizationIdQuery = currentOrganization
    ? `?organizationId=${currentOrganization}`
    : '';

  try {
    const response = await apiCall(
      `${process.env.NEXT_PUBLIC_API}${ROUTE}${organizationIdQuery}`,
      {
        method: 'GET',
        headers: {
          cookie: context?.req?.headers.cookie,
        },
      },
    );

    return response;
  } catch (error: any) {
    return { error };
  }
};

export const getAllUserOrganizations = async (
  context: GetServerSidePropsContext,
) => {
  const ROUTE = '/user/listOrganization';
  try {
    const response = await apiCall(`${process.env.NEXT_PUBLIC_API}${ROUTE}`, {
      method: 'GET',
      headers: {
        cookie: context?.req?.headers.cookie,
      },
    });

    return response;
  } catch (error: any) {
    return { error };
  }
};

export const validateOrganizationFunded = async (
  currentOrganization?: string | null,
) => {
  const ROUTE = '/organization/credits';
  const organizationIdQuery = currentOrganization
    ? `?organizationId=${currentOrganization}`
    : '';

  try {
    const response = await apiCall(
      `${process.env.NEXT_PUBLIC_API}${ROUTE}${organizationIdQuery}`,
      {
        method: 'GET',
      },
    );

    return response;
  } catch (error: any) {
    return { error };
  }
};

export const deleteOrganization = async (organizationId: string) => {
  const ROUTE = '/organization/delete';

  try {
    const response = await apiCall(
      `${process.env.NEXT_PUBLIC_API}${ROUTE}`,
      {
        method: 'DELETE',
      },
      { organizationId },
    );

    return response;
  } catch (error: any) {
    return { error };
  }
};
